import { styled } from '@mui/system';
import { Box, Grid } from '@mui/material';
import {
  SectionHeading,
  SectionSubtext,
  StepCard,
  CardHeader,
  DescriptionText,
} from '../../styles';
import { colors } from '../../../../../constants/theme';

export const PricingHeading = styled(SectionHeading)(({ theme }) => ({
  maxWidth: '870px',
  letterSpacing: '-.5px',
}));

export const PricingSubtext = styled(SectionSubtext)(({ theme }) => ({
  marginTop: '14px',
  maxWidth: '870px',
  letterSpacing: '0.4px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '18px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '22px',
  },
}));

export const PricingContentWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    paddingTop: '30px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    paddingTop: '40px',
  },
  [theme.breakpoints.up('md')]: {
    paddingTop: '50px',
  },
}));

export const PricingGridContainer = styled(Grid)(({ theme }) => ({
  alignItems: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '30px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    marginBottom: '40px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  [theme.breakpoints.up('lg')]: {
    marginBottom: '50px',
    flexWrap: 'nowrap',
  },
}));

export const PricingCardsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
    gap: '16px',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    height: 'auto',
    gap: '20px',
  },
  [theme.breakpoints.up('lg')]: {
    height: '600px',
  },
}));

export const PricingCardHeader = styled(CardHeader)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '20px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '18px',
    lineHeight: '22px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '20px',
    lineHeight: '24px',
  },
}));

export const PricingCard = styled(StepCard)(({ theme }) => ({
  borderRadius: '20px',
  minHeight: '84px',
  flexDirection: 'row',
  alignItems: 'flex-start',
  textAlign: 'left',
  maxWidth: '640px',
  [theme.breakpoints.down('sm')]: {
    padding: '12px 16px',
    minHeight: '70px',
    borderRadius: '16px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    padding: '14px 20px',
    borderRadius: '18px',
    maxWidth: '640px',
  },
  [theme.breakpoints.up('md')]: {
    padding: '16px 24px',
    borderRadius: '20px',
  },
}));

export const PricingCheckIcon = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
    margin: 'auto 12px auto 0',
    '& svg': {
      fontSize: '18px',
    },
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '20px',
    margin: 'auto 16px auto 0',
    '& svg': {
      fontSize: '20px',
    },
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '24px',
    margin: 'auto 20px auto 5px',
    '& svg': {
      fontSize: '24px',
    },
  },
}));

export const PricingCardTextWrapper = styled(Box)({
  flex: 1,
  minWidth: 0,
  alignSelf: 'center',
});

export const PricingCardText = styled(DescriptionText)(({ theme }) => ({
  color: colors.primary,
  fontWeight: 400,
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '15px',
    lineHeight: '22px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '17px',
    lineHeight: '24px',
  },
}));

export const PricingImageGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.down('lg')]: {
    order: 2,
    marginTop: '24px',
  },
  [theme.breakpoints.up('lg')]: {
    order: 0,
    marginTop: 0,
    flexShrink: 0,
  },
}));

export const PricingImageWrapper = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});

export const PricingImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: 'auto',
  display: 'block',
  objectFit: 'cover',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
    borderRadius: '24px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    maxWidth: '500px',
    borderRadius: '32px',
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: '600px',
    borderRadius: '40px',
  },
}));
